import { Component } from 'react';
// @ts-expect-error untyped module
import ErrorMessage from 'reporting-ui-components/components/shared/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export class ReportVisualizationErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  render() {
    const {
      error
    } = this.state;
    if (error) {
      return /*#__PURE__*/_jsx(ErrorMessage, {
        error: error
      });
    }
    return this.props.children;
  }
}